module.exports = __webpack_public_path__ + "static/media/2.2545d49a.JPG";